

















































import { defineComponent } from "@nuxtjs/composition-api";
import SwiperCarousel from "~/components/SwiperCarousel.vue";
import BannerList from "~/components/BannerList.vue";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import LazyComponent from "v-lazy-component/vue2";

export default defineComponent({
  name: "BannerSlider",
  components: {
    SkeletonPlaceholder,
    SwiperCarousel,
    BannerList,
    LazyComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const BannerOption = {
      slidesPerView: 1,
      pagination: { clickable: true },
      navigation: true,
      loop: true,
    };

    return {
      BannerOption,
    };
  },
});
